import React from 'react';
import { LuStore } from 'react-icons/lu';
import { Card, CardHeader } from '../../ui/Card';
import { Table, THead, Th, TBody, Tr, Td } from '../../ui/Table';
import Badge from '../../ui/Badge';
import Attributes from './Attributes';
import { formatDay } from '../../../utils/weekFormat.js';

const PROPOSAL_STATUS = { proposed: 'en attente', industrialized: 'industrialisée', rejected: 'rejetée' };
const MATCH_METHOD = { ai: 'choisi par l\'IA', alias: 'déjà trouvé pour ce nom' };

const formatScore = (value) => (value == null ? '—' : Number(value).toFixed(2));

const TopicCell = ({ row }) => (
  <div className="space-y-1">
    <p className="font-mono text-xs font-semibold text-gray-900 dark:text-white">{row.topic_code}</p>
    {row.dwh_topic_id
      ? <Badge size="sm" tone="blue" title={row.dwh_topic_id}>DWH</Badge>
      : <Badge size="sm" tone="amber" title={row.proposal_label || undefined}>Proposition {PROPOSAL_STATUS[row.proposal_status] || ''}</Badge>}
  </div>
);

const StoreMatch = ({ row }) => (row.store_id ? (
  <div className="flex flex-col items-end gap-1">
    <Badge tone="green" title={row.store_id}>
      Magasin <span className="font-mono">{row.store_id.slice(0, 8)}</span> · {formatScore(row.store_match_score)}
    </Badge>
    <span className="text-[11px] text-gray-400 dark:text-gray-500">{MATCH_METHOD[row.store_match_method] || row.store_match_method}</span>
  </div>
) : <Badge>Aucun magasin</Badge>);

const VisitBlock = ({ visit }) => {
  const first = visit.rows[0];
  return (
    <Card>
      <CardHeader
        icon={LuStore}
        title={`Visite ${visit.rank} · ${first.store_name_raw || first.shop_sign || 'sans magasin'}`}
        subtitle={[first.shop_sign, first.store_city_raw, formatDay(first.visit_date)].filter(Boolean).join(' · ')}
        actions={<StoreMatch row={first} />}
      />
      <Table>
        <THead>
          <Th>Topic</Th>
          <Th>Score</Th>
          <Th>Résumé</Th>
          <Th>Attributs</Th>
        </THead>
        <TBody>
          {visit.rows.map((row) => (
            <Tr key={row.topic_code}>
              <Td className="align-top">
                <TopicCell row={row} />
              </Td>
              <Td className="align-top font-mono text-xs">{formatScore(row.topic_score)}</Td>
              <Td className="min-w-[16rem] align-top text-sm text-gray-800 dark:text-gray-100">{row.summary}</Td>
              <Td className="min-w-[14rem] align-top">
                <Attributes value={row.attributes} />
              </Td>
            </Tr>
          ))}
        </TBody>
      </Table>
    </Card>
  );
};

export default VisitBlock;
